import { QuestionCircleFilled } from "@ant-design/icons"
import { Tooltip } from "antd"
import TextArea from "antd/es/input/TextArea"
import { useEffect, useState } from "react"
import { t } from "../../../languages/i18n"
interface HeaderScriptsProp {
  setHeaderScripts: (headerScripts: string) => void
  headerScripts: string
}
const HeaderScripts: React.FC<HeaderScriptsProp> = ({ headerScripts, setHeaderScripts }) => {
  const [headerScriptsInput, setHeaderScriptsInput] = useState<string>("")
  const handleChange = (e: any) => {
    setHeaderScriptsInput(e.target.value)
    setHeaderScripts(e.target.value)
  }
  useEffect(() => {
    setHeaderScriptsInput(headerScripts)
  }, [headerScripts])
  return (
    <div className="w-full flex flex-row gap-4 border-b pb-8">
      <div className="w-2/5 flex flex-col gap-2 ">
        <h2 className="text-base font-semibold">Header Scripts</h2>
        <p>{t("Paste your header scripts")}</p>
      </div>
      <div className=" w-3/5 flex flex-col gap-2 bg-white drop-shadow-md p-4 rounded-lg align-top">
        <div className="flex flex-row gap-2">
          <h2>Header Scripts</h2>
          <Tooltip title="Hướng dẫn thiết lập">
            <QuestionCircleFilled style={{ fontSize: 18 }} />
          </Tooltip>
        </div>
        <TextArea
          onChange={handleChange}
          value={headerScriptsInput}
          placeholder={t("Paste your header scripts here")}
          autoSize={{ minRows: 2, maxRows: 6 }}
        />
      </div>
    </div>
  )
}

export default HeaderScripts
